import facepaint from "facepaint";
import { breakpoints } from ".";

// TODO: Will change with getDeviceSizeString for all usage.
export const getMQString = () => {
  const { width, sm } = breakpoints;

  if (width <= sm) return "mobile";

  return "desktop";
};

const breakpointsSimple = {
  md: "768px",
  lg: "992px",
};

export const mediaQuery = facepaint(
  Object.keys(breakpointsSimple).map(
    (keyName) => `@media (min-width: ${breakpoints[keyName]})`
  )
);

export const getDeviceSizeString = (deviceSize, isWithoutTablet) => {
  if (!deviceSize) return "desktop";

  const { isMobile, isTablet } = deviceSize;

  if (isMobile) return "mobile";

  if (isTablet && !isWithoutTablet) {
    return "tablet";
  }

  if (isTablet) {
    return "mobile";
  }

  return "desktop";
};
